<template>
  <div class="flex px-3">
    <card class="shadow w-full">
      <div class="form-header bg-white px-4 py-4 border-b border-gray-200 flex justify-center sm:px-6">
        <div class="px-3 flex items-center justify-between w-full flex-wrap sm:flex-no-wrap"
             :class="{'max-w-6xl': $slots.default}">
          <div class="ml-4 flex items-center">
            <h3 class="text-lg leading-6 font-medium text-gray-900">
              {{title}}
            </h3>
            <slot name="header-left"></slot>
          </div>
          <div class="ml-4 flex-shrink-0">
              <slot name="header-right">
                <base-button v-if="showBackButton"
                             type="default"
                             outline
                             size="sm"
                             @click="goBack">
                  {{$t('generic.back')}}
                </base-button>
              </slot>
          </div>
        </div>
      </div>
      <form @submit.prevent="onSubmit" novalidate>
        <div v-if="$slots.default"
             class="max-w-6xl mx-auto py-4 px-4 sm:px-6 lg:px-8">
          <slot></slot>
        </div>
        <slot name="content"></slot>
        <div v-if="showFooter"
             class="form-footer px-4 py-3 bg-gray-50 text-center sm:px-6 overflow-hidden">
          <slot name="footer">
            <submit-button :loading="loading"
                           :disabled="disabled"
                           native-type="submit">
              {{saveText || $t('generic.save')}}
            </submit-button>
          </slot>
        </div>
      </form>
    </card>
  </div>
</template>
<script>
  export default {
    name: 'base-form',
    props: {
      title: {
        type: String,
        default: ''
      },
      loading: {
        type: Boolean,
        default: false
      },
      disabled: {
        type: Boolean,
        default: false
      },
      showFooter: {
        type: Boolean,
        default: true
      },
      showBackButton: {
        type: Boolean,
        default: true
      },
      saveText: {
        type: String,
        default: ''
      }
    },
    methods: {
      onSubmit(evt) {
        this.$emit('submit', evt)
      },
      goBack() {
        this.$router.go(-1)
      }
    }
  }
</script>
<style scoped>
  .form-footer {
    margin-bottom: -10px;
    @apply rounded-b-lg border-t border-gray-200;
  }
  .form-footer,
  .form-header {
    margin-left: -15px;
    margin-right: -15px;
  }
</style>
